import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import LoadEnrollmentInProgressTable from "../LoadEnrollment/LoadEnrollmentInProgressTable";
import { DeleteIconStyled } from "../LoadEnrollment/LoadEnrollment.styles";

const LoadAcquirerEnrollment = (props) => {
  const {
    setSubmenuAdministrativeOption,
    setSubmenuAdministrativeOpen,
    setSelectedOption,
    setNameSection,
  } = props;

  const columns = [
    { id: "acquirerName", label: "Acquirer Name" },
    { id: "countryCode", label: "Country Code" },
    {
      id: "enrollment_completed",
      label: "Status",
      format: (value) => (value ? "Completed" : "Pending"),
    },
    {
      id: "action",
      label: "Actions",
      actions: [
        {
          icon: <EditIcon />,
          label: "Set to Complete",
          onClick: () => {},
        },
        {
          icon: <DeleteIconStyled />,
          label: "Delete",
          onClick: () => {},
        },
      ],
    },
  ];

  return (
    <LoadEnrollmentInProgressTable
      enrollmentType="ACQUIRER"
      columns={columns}
      deleteLabelField="acquirerName"
      searchPlaceholder="Acquirer name or country"
      onContinue={() => {
        setSubmenuAdministrativeOpen(true);
        setSubmenuAdministrativeOption("acquirer_list");
        setSelectedOption("acquirer_form");
        setNameSection("Administrative - Acquirer Form");
      }}
    />
  );
};

export default LoadAcquirerEnrollment;
